import { Grid } from "../Grid";

export class QuickFind {
    private _grid: Grid;
    private _refreshCallback: () => void;
    constructor(grid: Grid) {
        this._grid = grid;
    }
    public get placeholder() {
        return this._grid.bindings?.SearchPlaceholder?.value ?? window.TALXIS.Portal.Translations.getLocalizedString('@pages/Control/View/index.tsx');
    }
    public init(refreshCallback: () => void) {
        this._refreshCallback = refreshCallback;
        this.refresh();
    }
    public get searchValue() {
        return this._grid.getSearchQuery();
    }
    public set searchValue(value: string) {
        this._grid.setSearchQuery(value);
        this.refresh();
        this._grid.refresh();
    }
    public refresh() {
        this._refreshCallback();
    }
    public isVisible(): boolean {
        return this._grid.cdsOptions.displayQuickFind;
    }
    public async getColumnDisplayNames(): Promise<string[]> {
        return this._grid.quickFindColumns.map(x => x.displayName);
    }
}